import { v4 as uuidv4 } from 'uuid'

export const useTweakwise = () => {
  const gtm = useGtm()
  const lastRequestId = useState<string | null>('twLastRequestId', () => null)
  const sessionKey = useState<string>('twSessionKey', () => '')
  const profileKey = useState<string>('profileKey', () => '')
  const { isLoggedIn, customerData } = useAccount()

  const track = (action: string, data: any) => {
    gtm?.push({
      event: 'tweakwise',
      action,
      data,
    })
  }

  onMounted(() => {
    const storedSessionKey = sessionStorage.getItem('twSessionKey')
    if (storedSessionKey) {
      sessionKey.value = storedSessionKey
    }

    watch (isLoggedIn, () => {
      handleCustomerOrGuestProfileKey().then(() => {
        if (!sessionKey.value) {
          sessionKey.value = uuidv4()
          track('sessionstart', {
            SessionKey: sessionKey.value,
            ProfileKey: profileKey.value,
          })
        }
      })
    }, { immediate: true })
  })

  watch(profileKey, (value) => {
    localStorage.setItem('twProfileKey', value)
  })
  watch(sessionKey, (value) => {
    sessionStorage.setItem('twSessionKey', value)
  })

  const handleCustomerOrGuestProfileKey = async () => {
    if (isLoggedIn.value) {
      profileKey.value = 'customer-' + btoa(customerData.value.email)
    }
    else {
      const stored = localStorage.getItem('twProfileKey')

      if (stored && stored.startsWith('guest-')) {
        profileKey.value = stored
      }
      else {
        generateProfileKey()
      }
    }
  }

  const generateProfileKey = () => {
    profileKey.value = 'guest-' + uuidv4()
  }

  return {
    sessionKey,
    profileKey,
    generateProfileKey,
    lastRequestId,
    track,
  }
}
